import * as React from "react";
import { greeting, memberNumber } from "./ProfileIntro.module.scss";

export const Title5: React.FC<any> = (props) => {
  return <div className={`${title5} d-inline`}>{props.children}</div>;
};
export const Greeting: React.FC<{ firstName: string }> = (props) => {
  return (
    <>
      <h3
        id={"hello-greeting"}
        className={`mb-4 mt-0 ${greeting}`}
      >{`Hello, ${props.firstName}`}</h3>
    </>
  );
};
export const MemberNumber: React.FC<{ memberNumber: string }> = (props) => {
  return (
    <div className={memberNumber}>
      {`Member Number: `}
      <span>{props.memberNumber}</span>
    </div>
  );
};
